// Pure logic for the User Page (/u/@handle): routing and count copy. The
// payload arrives already shaped for the viewer (see UserProfile), so there
// is nothing to reshape here. No side effects.

/**
 * Parse the bare `/u/@handle` into a route. Returns null for anything else;
 * `/u/@handle/wantlist` is the want list (`wantlist-logic.parseWantListRoute`),
 * which is where every bot link points.
 * @param {string} path
 * @returns {{ view: 'user', params: { handle: string } } | null}
 */
export function parseUserPageRoute(path) {
  if (!path || !path.startsWith('/u/')) return null;
  const parts = path.split('/').filter(Boolean); // ['u', '@handle']
  if (parts.length !== 2 || !parts[1].startsWith('@')) return null;
  const handle = parts[1].slice(1);
  if (!handle) return null;
  return { view: 'user', params: { handle } };
}

/**
 * @param {string} [handle] bare username (no '@') or 'me' (the default)
 */
export function buildUserPageUrl(handle) {
  const h = handle || 'me';
  return `/u/${h.startsWith('@') ? h : `@${h}`}`;
}

/** "1 card" / "1,284 cards" / "3 binders" */
export function countLabel(count, noun) {
  return `${count.toLocaleString()} ${noun}${count === 1 ? '' : 's'}`;
}

/** Binder corner badge tooltip / aria label. */
export function wantHitsTitle(count) {
  return `${countLabel(count, 'card')} you're looking for`;
}

/**
 * Header stat totals across the owner's binders. An unsynced Claim counts as
 * a binder with no cards.
 * @param {{ cardCount: number | null }[]} binders
 */
export function binderTotals(binders) {
  return { binders: binders.length, cards: binders.reduce((n, b) => n + (b.cardCount ?? 0), 0) };
}
